import React, { useState } from "react";
import { PlusCircle, FolderOpen } from "lucide-react";

export default function HomePanel({ onCreateNew, onLoadProject }) {
  const [blogIdInput, setBlogIdInput] = useState("");

  return (
  <div
    className="
      p-6 flex flex-col gap-6
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h2 className="text-2xl font-semibold flex items-center gap-2">
      Welcome to Reel Editor <span>🎬</span>
    </h2>

    {/* Description */}
    <p className="text-gray-600 dark:text-gray-400">
      Create a new reel or load an existing project linked to your blog.
    </p>

    {/* ───────── Create New Reel ───────── */}
    <button
      onClick={onCreateNew}
      className="
        flex items-center gap-3
        px-4 py-2 rounded-lg w-full
        bg-blue-600 hover:bg-blue-700
        text-white
        transition-colors
      "
    >
      <PlusCircle size={20} />
      Create New Reel
    </button>

    {/* ───────── Load Project ───────── */}
    <div className="flex flex-col gap-2 mt-2">
      <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
        Load Project by Blog ID
      </label>

      <input
        value={blogIdInput}
        onChange={(e) => setBlogIdInput(e.target.value)}
        placeholder="Enter blog ID..."
        className="
          p-2 rounded-md
          bg-white dark:bg-gray-800
          border border-gray-300 dark:border-gray-700
          text-gray-900 dark:text-gray-100
          placeholder:text-gray-400 dark:placeholder:text-gray-500
          focus:outline-none focus:ring-2 focus:ring-blue-500
        "
      />

      <button
        onClick={() => onLoadProject(blogIdInput)}
        className="
          flex items-center gap-3
          px-4 py-2 rounded-lg w-full
          bg-gray-200 hover:bg-gray-300
          dark:bg-gray-700 dark:hover:bg-gray-600
          text-gray-900 dark:text-white
          transition-colors
        "
      >
        <FolderOpen size={18} />
        Load Project
      </button>
    </div>
  </div>
);

}
